import React, { useState, useEffect, useContext } from 'react';
import { InputNumber } from 'antd';
import { formatCurrencyValue } from '../../../../utils';
import { Table } from 'react-bootstrap';
import EditProductQuantityModal from '../createPurchase/editProductQuantityModal';
import ScrollBox from '../../../../_components/ScrollBox';
import PurchaseContext from "../context";

const TableComponent = ({ data, currentPurchase, onRemoveItem }) => {
    const [showEditModal, setShowEditModal] = useState(false);
    const [currentItem, setCurrentItem] = useState({});
    const [purchase, setPurchase] = useState(currentPurchase);

    useEffect(() => {
        setPurchase(currentPurchase);
    }, [currentPurchase]);

    const handleSave = (value) => {
        const updatedItems = purchase.items.map(item =>
            item.id === value.id ? { ...item, quantity: value.quantity } : item
        );
        setPurchase({ ...purchase, items: updatedItems });
        setShowEditModal(false);
    };

    const handleEditClick = (item) => {
        setCurrentItem(item);
        setShowEditModal(true);
    };

    return (
        <ScrollBox>
            {purchase.items.length ? (
                <Table striped bordered hover responsive>
                    <thead>
                        <tr>
                            <th>Ações</th>
                            <th>Item</th>
                            <th>Cód.</th>
                            <th>Cód. Barras</th>
                            <th>Quantidade</th>
                            <th>Valor</th>
                            <th>Total</th>
                        </tr>
                    </thead>
                    <tbody>
                        {purchase.items.map((item, index) => {
                            item["index"] = index;
                            item.product = item.id;
                            item.quantity = item.quantity || 1;
                            if (item.sellable.name.length > 30) {
                                item.sellable.name = `${item.sellable.name.substring(0, 30)}...`;
                            }

                            const price = formatCurrencyValue(item.sellable.price);
                            const total = formatCurrencyValue(item.sellable.price * item.quantity);
                            const key = `pos-purchase-item-id-${item.id}-index-${index}`;
                            return (
                                <tr key={key}>
                                    <td title="Remover item">
                                        <i
                                            id={item.id}
                                            onClick={() => onRemoveItem(item.id)}
                                            style={{ cursor: "pointer" }}
                                            className="fas fa-trash text-danger ml-2"
                                        ></i>
                                    </td>
                                    <td>
                                        <strong>{item.sellable.name}</strong>
                                    </td>
                                    <td>
                                        <strong>{item.sellable.code}</strong>
                                    </td>
                                    <td>
                                        <strong>{item.sellable.barcode || "-"}</strong>
                                    </td>
                                    <td>
                                        <strong>
                                            {item.quantity}
                                            <i
                                                onClick={() => handleEditClick(item)}
                                                title="Atualizar a quantidade"
                                                style={{ cursor: "pointer" }}
                                                className="fas fa-edit ml-2"
                                            ></i>
                                        </strong>
                                    </td>
                                    <td>{price}</td>
                                    <td>{total}</td>
                                </tr>
                            );
                        })}
                    </tbody>
                </Table>
            ) : (
                <h1>Vazio!</h1>
            )}

            <EditProductQuantityModal
                show={showEditModal}
                onHide={() => setShowEditModal(false)}
                onSave={handleSave}
                item={currentItem}
            />
        </ScrollBox>
    );
};

export default TableComponent;



// WEBPACK FOOTER //
// ./src/views/AppViews/Purchases/components/tableComponent.js